import React from 'react';

import CopiableURL from "../../CopiableURL"
import {convertToVagas, removeAllParamsURL, getUrlVars, BADGES} from "../../../services/helpers";

const Yourl = (props) => {

    const { clicks } = props;
    const tags = getUrlVars(props.link.url);

    return (
        <div key={props.link.created_at}>
            <div className='click-box'> <p className='clicks-quant'>{clicks}</p> Cliques</div>
            <p>
                <span className='link-title'>{props.link.title}</span>
                <br />
                <CopiableURL
                    url={removeAllParamsURL(props.link.url)}
                    text={removeAllParamsURL(props.link.url)}
                />
                <br />
                <CopiableURL url={props.link.shorturl} text={props.link.shorturl} />
                <br/>
                <CopiableURL url={props.link.shorturl? convertToVagas(props.link.shorturl): ''} text={props.link.shorturl? convertToVagas(props.link.shorturl): ''} />
                <br />
                { tags ? tags.map((tag, index) => {
                    return (
                        <span key={index} className={`tags badge ${BADGES[index]}`}>
                            {tag}
                        </span>
                    );
                }): <> </>}
            </p>
            <hr />
        </div>
    );
            }
export default Yourl;
